import Router from 'vue-router';
import Vue from 'vue';
import system from './system';
import { Toast } from 'vant';
import axios from 'axios';

Vue.use(Router);

const router = new Router({
  mode: 'history', // history下需要在nginx中另加配置
  scrollBehavior: () => ({ y: 0 }),
  // base: process.env.NODE_ENV === 'production' ? '/gt/' : '/',
  base: process.env.NODE_ENV === 'production' ? '/' : '/',
  routes: system
});

const loadingToast = Toast.loading({
  overlay: true,
  message: '加载中...'
});

router.beforeEach((to, from, next) => {
  loadingToast.open();
  // 添加description 和 keyword
  let content = {
    keyword: '瑞安市国有资产投资集团有限公司,瑞安国投集团官网,瑞安国投集团,国投集团',
    description: '瑞安市国有资产投资集团有限公司,瑞安国投集团官网,瑞安国投集团,国投集团'
  };
  let keyword = '瑞安市国有资产投资集团有限公司,瑞安国投集团官网,瑞安国投集团,国投集团';
  let description = '瑞安市国有资产投资集团有限公司,瑞安国投集团官网,瑞安国投集团,国投集团';
  let head = document.getElementsByTagName('head');
  let meta = document.createElement('meta');
  document.querySelector('meta[name="keywords"]').setAttribute('content', keyword);
  document.querySelector('meta[name="description"]').setAttribute('content', description);
  meta.content = content;
  head[0].appendChild(meta);
  if (to.meta.title) {
    //判断是否有标题
    document.title = to.meta.title;
  }
  // console.log('www.ragtjt.com' + to.path);
  axios({
    method: 'post',
    url: 'http://data.zz.baidu.com/urls?site=' + 'www.ragtjt.com' + '&token=' + 'kGENrEENmQ51GZb3',
    data: 'http://www.ragtjt.com' + to.path,
    contentType: 'text/plain',
    headers: {
      'Access-Control-Allow-Origin': '*'
    }
  });
  // console.log(from.path + ' route to ' + to.path);
  if (to.path === from.path) {
    next(false);
  }
  next();
});

// eslint-disable-next-line no-unused-vars
router.afterEach((to, from) => {
  loadingToast.clear();
  window.scrollTo(0, 0);
});
export default router;
